/** Small inline flags (emoji flags don't show on Windows). */
export function FlagPK({ className = 'h-3 w-[18px]' }: { className?: string }) {
  return (
    <svg viewBox="0 0 30 20" className={`${className} shrink-0 rounded-[2px] shadow-[0_0_0_0.5px_rgba(0,0,0,0.2)]`} aria-hidden>
      <rect width="30" height="20" fill="#01411C" />
      <rect width="7.5" height="20" fill="#fff" />
      <circle cx="19.2" cy="10" r="5.6" fill="#fff" />
      <circle cx="20.6" cy="8.9" r="4.9" fill="#01411C" />
      <path d="M22.9 6.2l.62 1.62 1.73.07-1.36 1.08.47 1.67-1.46-.96-1.44.97.46-1.67-1.36-1.08 1.73-.08z" fill="#fff" />
    </svg>
  )
}

export function FlagJP({ className = 'h-3 w-[18px]' }: { className?: string }) {
  return (
    <svg viewBox="0 0 30 20" className={`${className} shrink-0 rounded-[2px] shadow-[0_0_0_0.5px_rgba(0,0,0,0.2)]`} aria-hidden>
      <rect width="30" height="20" fill="#fff" />
      <circle cx="15" cy="10" r="6" fill="#BC002D" />
    </svg>
  )
}
